module.exports = __webpack_public_path__ + "static/slide9-f339d9acc79a8f6a84355cb5f4236028.jpg";